import { PrimaryButton, SecondaryButton } from "@digipost/dds-buttons-react";
import { Heading } from "@digipost/dds-heading-react";
import { FC } from "react";
import { Link } from "react-router";

import { AppCommercialBanner } from "../appCommercialBanner/AppCommercialBanner";
import Chatbot from "../chatbot/Chatbot";
import Translated from "../infrastructure/components/Translated";
import { useRootPath } from "../infrastructure/hooks/useRootPath";
import Dameistol from "./dameistol.svg?react";
import styles from "./logout.module.less";

const Logout: FC<{ timeout: boolean }> = ({ timeout }) => {
  const variants = ["timeout_", "user_"] as const;
  const rootPath = useRootPath();

  return (
    <>
      <div className={styles.outerContainer}>
        <div className={`${styles.logoutBox} ${styles.innerContainerLogout}`}>
          <div>
            <Heading level={1} size={"large"} className={styles.logoutHeading}>
              <Translated
                textKey={`logout.${timeout ? variants[0] : variants[1]}heading`}
              />
            </Heading>
            <p className={styles.logoutSubheading}>
              {timeout && <Translated textKey={"logout.timeout_subheading"} />}
            </p>
            <div className={styles.logoutLoginContainer}>
              <PrimaryButton size="large" as={Link} to={`${rootPath}/`}>
                <Translated textKey="logout.login_to_private_button" />
              </PrimaryButton>
              <SecondaryButton
                size="large"
                as={Link}
                to={`${rootPath}/business`}
              >
                <Translated textKey="logout.login_to_org_button" />
              </SecondaryButton>
            </div>
          </div>
          <div className={styles.imageBox}>
            <Dameistol />
          </div>
        </div>
        <AppCommercialBanner />
        <Chatbot />
      </div>
    </>
  );
};

export default Logout;
